import {Div, HeaderBack, ImageView, Label, LoadingIndicator} from 'components';
import {Ecolors, Icons, urlApp} from 'constant';
import React, {useEffect, useState} from 'react';
import {ScrollView, StyleSheet} from 'react-native';
import {useDispatch} from 'react-redux';
import {changeUserPhotos} from 'reducer/authen';
import {
  getInvestmentProfile,
  getStatusEditProfile,
} from 'reducer/authen/selector';
import {apiAuth, navigate} from 'services';
import {apiMain} from 'services/apis/apiMain';
import {useAppSelector} from 'store/hooks';
import {convertTimestamp, getUuid, widthScale, widthScreen} from 'utils';
import {getStoreToken} from 'utils/storage';

function RowSpaceItem(p: {paddingTop?: number; children?: any}) {
  return (
    <Div
      height={54}
      paddingHorizontal={16}
      borderBottomWidth={1}
      borderBottomColor={Ecolors.spaceColor}
      paddingTop={p.paddingTop ?? 0}
      flexDirection={'row'}
      alignItems={'center'}
      justifyContent={'space-between'}>
      {p.children && p.children}
    </Div>
  );
}

function AccountInfoModal() {
  const currentUser = useAppSelector(state => state.authen.currentUser);
  const investmentProfile = useAppSelector(state =>
    getInvestmentProfile(state),
  );
  const [listImage, setListImage] = useState<Array<any>>([]);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState<boolean>(false);
  const [country, setCountry] = useState<any>(null);
  const [typeId, setTypeId] = useState<any>({});
  const isEdit = useAppSelector(state => getStatusEditProfile(state));
  const {
    email,
    phone,
    name,
    gender,
    dob,
    idTypeId,
    idNo,
    dateOfIssue,
    placeOfIssue,
    mailingCountryId,
    nationalityId,
    userPhotos,
    investorTypeId,
    countryId,
    visaNo,
  } = currentUser;

  useEffect(() => {
    getCountry();
    downloadImage(currentUser?.userPhotos || []);
    getSource();
    return () => {};
  }, []);

  const getSource = async () => {
    try {
      if (investorTypeId == 2) {
        const listForOrg = await apiAuth.listForOrg();
        if (listForOrg.status == 200) {
          setTypeId(listForOrg.data.find((item: any) => item.id == idTypeId));
        }
        return;
      }
      const listForIndivi = await apiAuth.listForIndivi();
      if (listForIndivi.status == 200) {
        setTypeId(listForIndivi.data.find((item: any) => item.id == idTypeId));
      }
    } catch (error) {}
  };

  const downloadImage = async (photo: Array<any>) => {
    return;
    setListImage(
      currentUser?.userPhotos?.map(
        (item: any, index: number) => item?.base64Convert || '',
      ),
    );
    try {
      setLoading(true);
      const token = await getStoreToken();
      const t = await Promise.all(
        photo.map(async (item: any, index: number) => {
          const ul = `download/file?uri=${item.url}`;
          const bburl = `${urlApp.APIURL}api/${ul}`;
          return new Promise((resolve, reject) => {
            try {
              ReactNativeBlobUtil.config({})
                .fetch(
                  'POST',
                  bburl,
                  {
                    Authorization: token ? `Bearer ${token}` : '',
                    'Content-Type': 'application/json',
                    'request-id': getUuid(),
                    Origin: urlApp.DomainName,
                  },
                  JSON.stringify({
                    uri: item.url,
                  }),
                )
                .then((r: any) => {
                  setLoading(false);
                  resolve(r.base64());
                  return;
                });
            } catch (error) {
              reject(error);
            }
          });
        }),
      );
      if (!!t.length) {
        setListImage(
          t.map((item: any, index: number) => {
            return `data:image/png;base64,${item}`;
          }),
        );
        const newList = photo.map((item: any, index: number) => {
          return {
            ...item,
            base64Convert: `data:image/png;base64,${t[index]}`,
          };
        });
        dispatch(changeUserPhotos(newList));
      }
    } catch (error) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const getCountry = async () => {
    try {
      const res = await apiMain.getCountry();
      const c = res.data.find(
        (a: any) => a.id == mailingCountryId || a.id == nationalityId,
      );
      if (c) {
        setCountry(c);
      }
    } catch (error) {}
  };

  return (
    <Div height={'100%'} backgroundColor={Ecolors.whiteColor}>
      <HeaderBack
        type={2}
        iconRight={isEdit ? Icons.edit : null}
        loading={loading}
        title={`accountverify.thongtincanhan`}
        onRightPress={() => {
          if (loading) {
            return;
          }
          navigate('EditAccountInfoModal');
        }}
      />
      <ScrollView>
        <Div
          flexDirection={'row'}
          alignItems={'center'}
          justifyContent={'flex-start'}
          paddingHorizontal={16}
          height={48}
          backgroundColor={'rgba(73, 85, 163, 0.1)'}>
          <Label>{`accountverify.thongtinnhadautu`}</Label>
        </Div>
        <RowSpaceItem>
          <Label>{`accountverify.hoten`}</Label>
          <Label multilanguage={false}>{name}</Label>
        </RowSpaceItem>
        <RowSpaceItem>
          <Label>{`accountverify.gioitinh`}</Label>
          <Label>
            {gender === 1 ? `accountverify.nam` : `accountverify.nu`}
          </Label>
        </RowSpaceItem>
        <RowSpaceItem>
          <Label>{`accountverify.ngaysinh`}</Label>
          <Label multilanguage={false}>{convertTimestamp(dob)}</Label>
        </RowSpaceItem>
        <RowSpaceItem>
          <Label>{`accountverify.quoctich`}</Label>
          <Label multilanguage={false}>{country?.name || ''}</Label>
        </RowSpaceItem>
        {countryId != 234 && (
          <RowSpaceItem>
            <Label>{`accountverify.sothithucnhapcanh`}</Label>
            <Label multilanguage={false}>{visaNo || ''}</Label>
          </RowSpaceItem>
        )}
        <RowSpaceItem>
          <Label>{`accountverify.email`}</Label>
          <Label multilanguage={false}>{email}</Label>
        </RowSpaceItem>
        <RowSpaceItem>
          <Label>{`accountverify.sodienthoai`}</Label>
          <Label multilanguage={false}>{phone}</Label>
        </RowSpaceItem>
        {/*  */}
        <Div
          flexDirection={'row'}
          alignItems={'center'}
          justifyContent={'flex-start'}
          paddingHorizontal={16}
          height={48}
          backgroundColor={'rgba(73, 85, 163, 0.1)'}>
          <Label>{`accountverify.thongtincmnd`}</Label>
        </Div>
        <RowSpaceItem>
          <Label>{`accountverify.loaigiayto`}</Label>
          <Div
            flex={1}
            flexDirection="row"
            alignItems="center"
            justifyContent="flex-end">
            <Label textAlign="right" multilanguage={false}>
              {typeId?.name || ''}
            </Label>
          </Div>
        </RowSpaceItem>
        <RowSpaceItem>
          <Label>{`accountverify.sohieugiayto`}</Label>
          <Label multilanguage={false}>{idNo}</Label>
        </RowSpaceItem>
        <RowSpaceItem>
          <Label>{`accountverify.ngaycap`}</Label>
          <Label multilanguage={false}>{convertTimestamp(dateOfIssue)}</Label>
        </RowSpaceItem>
        <RowSpaceItem>
          <Label>{`accountverify.noicap`}</Label>
          <Div
            flex={1}
            flexDirection={'row'}
            paddingLeft={10}
            alignItems={'center'}
            justifyContent={'flex-end'}>
            <Label multilanguage={false}>{placeOfIssue}</Label>
          </Div>
        </RowSpaceItem>
        {loading && (
          <Div alignItems={'center'} paddingTop={10} justifyContent={'center'}>
            <LoadingIndicator color={Ecolors.mainColor} numdot={3} />
          </Div>
        )}
        <Div
          padding={16}
          flexDirection={'row'}
          alignItems={'center'}
          justifyContent={'space-between'}>
          {listImage?.map((item: any, index: number) => {
            return (
              <Div
                width={162}
                overflow={'hidden'}
                height={103}
                key={index}
                borderRadius={5}
                borderWidth={1}
                borderColor={Ecolors.bordercolor}>
                <ImageView
                  width={162}
                  height={103}
                  source={{
                    uri: item,
                  }}
                />
              </Div>
            );
          })}
        </Div>

        <Div height={200} />
      </ScrollView>
    </Div>
  );
}

const s = StyleSheet.create({
  imgContainer: {
    width: '100%',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: widthScale(200),
  },
  sbutton: {
    width: widthScreen - widthScale(30),
    height: widthScale(200),
  },
});

export default React.memo(AccountInfoModal);
